<template>
  <div class="ads-vertical">
    <google1x1 />
    <google-profile-vertical v-if="!isSmallScreen" />
  </div>
</template>

<script>
import Google1x1 from "@/components/Ads/Google1x1";
import GoogleProfileVertical from "@/components/Ads/GoogleProfileVertical";

export default {
  name: "AdsVertical",
  components: { GoogleProfileVertical, Google1x1 },

  data() {
    return {
      windowWidth: window.innerWidth
    }
  },

  computed: {
    isSmallScreen() {
      return this.windowWidth <= 900;
    }
  },

  created() {
    this.handleResize = () => {
      this.windowWidth = window.innerWidth;
    };
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped lang="scss">
.ads-vertical {
  display: inline-block;
  height: 600px;
  width: 300px;
  overflow: hidden;

  & > div {
    padding: 0;
  }
}

@media screen and (max-width: 1150px) {
  .ads-vertical {
    width: 160px;
  }
}

@media screen and (max-width: 900px) {
  .ads-vertical {
    display: none;
  }
}
</style>
